import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const Alert = (props) => {

    const handleClose = () => props.setShowAlert(false);
    const handleAcept = () => {
        props.setShowAlert(false);
        if (!props.onlyAlert)
            props.onClickAcept()
    }

    return (
        <>
            <Modal show={props.showAlert} onHide={handleClose} animation={true} className="text-center"
                   size="sm" centered={true} backdrop='static' aria-modal={true}>
                <br/>
                <FontAwesomeIcon icon={props.icon} color="orange" size="3x"/>
                <br/>
                <Modal.Title>{props.title}</Modal.Title>
                <Modal.Body>{props.body}</Modal.Body>
                <div className="row">
                    <div className="col-12">
                        {!props.onlyAlert && (
                            <Button variant="secondary" onClick={handleClose} style={{marginRight: '5px'}}>
                                {props.buttomCancel}
                            </Button>
                        )}
                        <Button variant="danger" onClick={handleAcept}>
                            {props.buttomAcept}
                        </Button>
                    </div>
                </div>
                <br/>
            </Modal>
        </>
    );


}

export default Alert


